import { Divider } from "@/components/shared/divider";
import { X } from "@/components/shared/icons";
import { Typography } from "@/components/shared/typography";
import { Button, Dialog, DialogContent, View } from "@/components/ui";
import { downloadFromUrl } from "@/lib/platform";

import type { PayNowScreenModalProps } from "../type";
import { OurBankDetail } from "./our-bank-detail";
import { OurPayNowDetail } from "./our-paynow-detail";
import { PaymentDetail } from "./payment-detail";
import { Qr } from "./qr";

export const PayNowScreenModal = ({
  open,
  invoiceId,
  accountNumber,
  uenNumber,
  merchantName,
  onCopyAccountNumber,
  onCopyUenNumber,
  onCopyReference,
  paymentQrUri,
  onClose,
  onConfirmTransfer,
  loading,
  baseAmount,
  amount,
  balance,
  appliedVoucher,
}: PayNowScreenModalProps) => {
  const onDownloadQr = () => {
    downloadFromUrl(paymentQrUri, "LUCE_QR_INVOICE_" + invoiceId + ".png");
  };
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-background-intermediate flex max-h-[90dvh] max-w-[560px] flex-col gap-0 overflow-hidden p-0">
        <View className="shrink-0 bg-white p-3">
          <View className="flex flex-row items-center justify-between">
            <Typography variant="label-sm">PayNow / Bank Transfer</Typography>
            <View className="cursor-pointer" onClick={onClose} role="button" aria-label="Close">
              <X size={28} className="text-foreground-attenuated" />
            </View>
          </View>
        </View>
        <View className="min-h-0 flex-1 overflow-auto">
          <View className="flex flex-col gap-6 p-3">
            <PaymentDetail
              baseAmount={baseAmount}
              amount={amount}
              balance={balance}
              appliedVoucher={appliedVoucher}
            />
            <OurBankDetail
              merchantName={merchantName}
              accountNumber={accountNumber}
              invoiceId={invoiceId}
              onCopyAccountNumber={onCopyAccountNumber}
              onCopyReference={onCopyReference}
            />
            <OurPayNowDetail
              uenNumber={uenNumber}
              invoiceId={invoiceId}
              onCopyUenNumber={onCopyUenNumber}
              onCopyReference={onCopyReference}
            >
              <Divider className="my-2" />
              <Qr paymentQrUri={paymentQrUri} onDownloadQr={onDownloadQr} />
            </OurPayNowDetail>
          </View>
        </View>
        <View className="flex shrink-0 flex-col gap-2 bg-white p-3">
          <View className="flex flex-row items-center justify-between gap-2">
            <Typography variant="body-sm" color="foreground-default">
              Total
            </Typography>
            <View className="flex flex-row items-end gap-1">
              <Typography variant="label-sm" color="brand-primary">
                {balance}
              </Typography>
              {!!amount && (
                <Typography variant="caption-md" color="foreground-intermediate" className="mb-1">
                  incl. GST
                </Typography>
              )}
            </View>
          </View>
          <View className="flex flex-col gap-2">
            <View className="flex w-full flex-col gap-3">
              <Button variant="secondary" color="CTA2" fullWidth="full" onClick={onClose}>
                I'll transfer my money later
              </Button>
              <Button
                variant="primary"
                color="CTA"
                fullWidth="full"
                onClick={onConfirmTransfer}
                disabled={loading}
              >
                I've made my bank transfer
              </Button>
            </View>
          </View>
        </View>
      </DialogContent>
    </Dialog>
  );
};
